import { get } from './helpers'

export default {
  fetchCardInfo() {
    return get('api/card_info')
  }
}
